import React from 'react'
import posed, { PoseGroup } from 'react-pose'
import StoreDetails from './StoreDetails'
import StoreDetailsIcon from '../../assets/icons/icon-store.svg'
import ArrowRightIcon from '../../assets/icons/icon-arrow-right.svg'

const Modal = posed.div({
  css: {
    willChange: 'transform',
  },
  enter: {
    x: 0,
    transition: {
      duration: 500,
      ease: [0.19, 1, 0.22, 1],
    },
  },
  exit: {
    x: '100%',
    transition: {
      duration: 500,
      ease: [0.19, 1, 0.22, 1],
    },
  },
})

const Shade = posed.div({
  css: {
    willChange: 'opacity',
  },
  enter: { opacity: 1 },
  exit: { opacity: 0 },
})

const PosedStoreLink = posed.div({
  start: { opacity: 0, y: '20px' },
  end: {
    opacity: 1,
    y: '0px',
    delay: 1600,
    transition: {
      duration: 500,
    },
  },
})

const StoreInfo = ({ storeData, showStoreDetails, onStoreDetailsClick }) => {
  return (
    <>
      {storeData && (
        <PosedStoreLink initialPose="start" pose="end">
          <div
            data-cy="store-info"
            className="flex px-4 py-3 mb-4 border rounded-lg cursor-pointer border-secondary bg-body-lightest text-secondary"
            onClick={() => onStoreDetailsClick(true)}
          >
            <span className="block">
              <img
                src={StoreDetailsIcon}
                alt="store details"
                className="block w-auto h-4 mt-1"
              />
            </span>
            <div className="flex-1 px-3">
              <p className="font-semibold select-none" data-cy="store-name">
                {storeData.storeName}
              </p>
              <p className="text-sm underline select-none">
                view store details
              </p>
            </div>
            <span className="self-center block">
              <img
                src={ArrowRightIcon}
                alt="open store details"
                className="block w-4 h-3"
              />
            </span>
          </div>
        </PosedStoreLink>
      )}
      <PoseGroup flipMove={false}>
        {showStoreDetails && [
          <Shade key="shade" className="fixed inset-0 bg-black-50" />,
          <Modal
            key="modal"
            className="fixed bottom-0 right-0 z-50 w-full pl-6 lg:max-w-lg"
          >
            <StoreDetails
              data={storeData}
              onClose={() => onStoreDetailsClick(false)}
            />
          </Modal>,
        ]}
      </PoseGroup>
    </>
  )
}

export default StoreInfo
